import { combineReducers } from "redux";

// --- Slice imports (RTK createSlice) ---
import {
  tokenReducer,
  pcmsTokenReducer,
  pbiTokenReducer,
  userDetailsReducer,
} from "../slices/authSlice";
import { alertReducer } from "../slices/alertSlice";
import {
  getDashboardReducer,
  insightsReducer,
} from "../slices/dashboardSlice";
import {
  territoryDetailsReducer,
  clusterCodeReducer,
  RBDMCodeReducer,
} from "../slices/territorySlice";
import {
  marketWorkingReducer,
  barGraphReducer,
  visitDetailsReducer,
  upcomingTourPlanReducer,
  pastInsightReducer,
  getFeedbackReducer,
} from "../slices/marketWorkingSlice";
import {
  getUserTypeReducer,
  impersonationReducer,
  setSessionAlertReducer,
  setCheckInFlagReducer,
  masterFetchStatusReducer,
  setSelectedSalesGroupCode,
} from "../slices/userSlice";
import {
  getDivisionGroupReducer,
  queryDetailsReducer,
  productReducer,
} from "../slices/dataSlice";
import {
  wssOptionsReducer,
  townOptionsReducer,
  bmWssReducer,
  rmdmTownReducer,
} from "../slices/wssSlice";
import {
  currentDayTourReducer,
  HoUserSh7CodeReducer,
  mvrDraftReducer,
  salesgroupUserReducer,
  myUserFeedbackReducer,
} from "../slices/miscSlice";
import { getMyDiaryDetailsReducer } from "../slices/diarySlice";
import { uiModalReducer } from "../slices/uiSlice";
import { oaapReducer } from "../slices/oaapSlice";
import { jcReducer } from "../slices/jcSlice";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "tokens",
    "pcmsToken",
    "userDetails",
    "territory",
    "getFeedback",
    "barGraph",
    "marketWorking",
    "visitDetails",
    "upcomingTourPlan",
    "dashBoardDetails",
    "divisionGroup",
    "clusterCode",
    "currentDayTour",
    "HoUserSh7Code",
    "product",
    "myUserFeedback",
    "rmdmTown",
    "mvrDraft",
    "bmWss",
    "salesgroupUser",
    "RBDMCode",
    "userType",
    "wssOptionsData",
    "townOptionsData",
    "SelectedSalesGroupCode",
    "myDiaryDetails",
    "impersonation",
  ],
};

const reducers = combineReducers({
  tokens: tokenReducer,
  pbiToken: pbiTokenReducer,
  pcmsToken: pcmsTokenReducer,
  userDetails: userDetailsReducer,
  alerts: alertReducer,
  query: queryDetailsReducer,
  territory: territoryDetailsReducer,
  marketWorking: marketWorkingReducer,
  barGraph: barGraphReducer,
  visitDetails: visitDetailsReducer,
  upcomingTourPlan: upcomingTourPlanReducer,
  pastInsight: pastInsightReducer,
  getFeedback: getFeedbackReducer,
  divisionGroup: getDivisionGroupReducer,
  dashBoardDetails: getDashboardReducer,
  insights: insightsReducer,
  clusterCode: clusterCodeReducer,
  currentDayTour: currentDayTourReducer,
  HoUserSh7Code: HoUserSh7CodeReducer,
  product: productReducer,
  myUserFeedback: myUserFeedbackReducer,
  rmdmTown: rmdmTownReducer,
  mvrDraft: mvrDraftReducer,
  bmWss: bmWssReducer,
  wssOptionsData: wssOptionsReducer,
  townOptionsData: townOptionsReducer,
  salesgroupUser: salesgroupUserReducer,
  RBDMCode: RBDMCodeReducer,
  userType: getUserTypeReducer,
  sessionAlert: setSessionAlertReducer,
  SelectedSalesGroupCode: setSelectedSalesGroupCode,
  checkInFlag: setCheckInFlagReducer,
  masterFetchStatus: masterFetchStatusReducer,
  impersonation: impersonationReducer,
  myDiaryDetails: getMyDiaryDetailsReducer,
  uiModal: uiModalReducer,
  oaap: oaapReducer,
  jc: jcReducer,
});

export default persistReducer(persistConfig, reducers);
